'use client'

import NextImage from 'next/image'
import React from 'react'

import { cn } from '@/utilities/ui'
import type { Props as MediaProps } from '@/types/Media'

export const ImageMedia: React.FC<MediaProps> = (props) => {
  const { alt: altFromProps, fill, imgClassName, priority, resource, size } = props

  let width: number | undefined
  let height: number | undefined
  let alt = altFromProps
  let src = ''

  if (resource && typeof resource === 'object') {
    const { alt: altFromResource, height: fullHeight, url, width: fullWidth, updatedAt } = resource

    width = fullWidth ?? undefined
    height = fullHeight ?? undefined
    alt = altFromResource || alt || ''
    src = `${url}?${updatedAt}`
  }

  if (!src) return null

  return (
    <NextImage
      alt={alt || ''}
      className={cn('object-cover', imgClassName)}
      fill={fill}
      height={!fill ? height : undefined}
      width={!fill ? width : undefined}
      priority={priority}
      quality={80}
      sizes={size ?? '(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw'}
      src={src}
    />
  )
}
